<div class="report flex__child--auto flex--column" data-test="report">
  <router-outlet></router-outlet>
</div>
